import { render } from "./ResetAction.vue?vue&type=template&id=09812bd4&scoped=true"
const script = {}

import "./ResetAction.vue?vue&type=style&index=0&id=09812bd4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09812bd4"

export default script